import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, border, colors }) => ({
  pressable: {
    _web: {
      _focus: {
        outline: "none",
      },
      "_focus-visible": {
        outlineStyle: "solid",
        outlineColor: colors.borderFocus,
        outlineWidth: border.widths.xl,
        outlineOffset: border.widths.xl,
        borderRadius: border.radius.md,
      },
    },
  },
  card: {
    variants: {
      type: {
        portrait: {
          aspectRatio: 2 / 3,
          height: {
            xs: spacing(64),
            md: spacing(72),
            lg: spacing(84),
          },
        },
        landscape: {
          aspectRatio: 16 / 9,
          height: {
            xs: spacing(36),
            md: spacing(42),
            lg: spacing(54),
          },
        },
      },
    },
  },
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    justifyContent: "center",
    padding: spacing(2),
    zIndex: 1,
  },
  nextOverlay: {
    right: spacing(4),
    variants: {
      canScrollNext: {
        false: {
          display: "none",
        },
      },
    },
  },
}));

const initialTheme = UnistylesRuntime.getTheme();

export const IMAGE_DIMENSIONS = {
  card: {
    portrait: [
      {
        width: initialTheme.spacing(64) * (2 / 3),
        height: initialTheme.spacing(64),
      }, // for 2:3, xs
      {
        width: initialTheme.spacing(72) * (2 / 3),
        height: initialTheme.spacing(72),
      }, // for 2:3, md
      {
        width: initialTheme.spacing(84) * (2 / 3),
        height: initialTheme.spacing(84),
      }, // for 2:3, lg
    ],
    landscape: [
      {
        width: initialTheme.spacing(36) * (16 / 9),
        height: initialTheme.spacing(36),
      }, // for 16:9, xs
      {
        width: initialTheme.spacing(42) * (16 / 9),
        height: initialTheme.spacing(42),
      }, // for 16:9, md
      {
        width: initialTheme.spacing(54) * (16 / 9),
        height: initialTheme.spacing(54),
      }, // for 16:9, lg
    ],
  },
};

export default stylesheet;
